import { render, staticRenderFns } from "./Dart.vue?vue&type=template&id=72b2ee6c&scoped=true"
import script from "./Dart.vue?vue&type=script&lang=js"
export * from "./Dart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b2ee6c",
  null
  
)

export default component.exports